import { useMemo } from "react";
import { useSpace } from "../Spaces/SpaceContext"
import { ContactFieldsKeys, ContactFieldsSettingKey } from "./ContactsSettingsEdit";
import { ProjectField } from "../Projects/useProjectsSettings";


export const useContactsSettings = () => {
  const { settings } = useSpace();

  const fields = useMemo(() => {
    const projectFieldsSettings = (settings.settings || {})[ContactFieldsSettingKey] || {};
    return ContactFieldsKeys
      .map(k => ({ key: k, is_enabled: false, ...(projectFieldsSettings[k] || {})}) as ProjectField)
      .filter(x => x.is_enabled)
      .sort((a,b) => (a.sortorder || 0) < (b.sortorder || 0) ? -1 : 1)
  }, [settings.settings]);

  return {
    fields,
  }
}
